<template>
  <s-select
    v-if="!multiple"
    v-bind="finalSelectBinds"
    v-model="valueProxy"
    v-on="selectEvents"
    :disabled="disabled"
  />
  <s-multiselect
    v-else
    v-model="valueProxy"
    :proxy-binds="finalSelectBinds"
    :proxy-events="selectEvents"
  />
</template>
<script>
import EnumSelectBuilder from './enumSelectBuilder';

export default {
  computed: {
    valueProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    finalSelectBinds() {
      return {
        ...EnumSelectBuilder({
          enumDefinition: this.enumDefinition,
          translationPath: this.translationPath,
          includeSelectOption: !this.multiple && !this.noSelectOption,
          selectOptionTranslation: this.selectOptionTranslation,
          sort: !this.noSort,
          forMultiSelect: this.multiple,
        }),
        ...this.selectBinds,
        skipInitializeValue: this.skipInitializeValue,
      };
    },
  },
  props: {
    value: null,
    enumDefinition: {
      type: [Array, Object],
    },
    translationPath: {
      type: String,
    },
    noSelectOption: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectOptionTranslation: {
      type: String,
      default: 'general.select',
    },
    noSort: {
      type: Boolean,
      default: false,
    },
    selectBinds: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    selectEvents: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    skipInitializeValue: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
